import React from 'react';
import Slider from 'react-slick';
import UseData from '../Hooks/UseData';

const SliderCommon = () => {
  const { sliderImg } = UseData();

  // responsive slider element

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: sliderImg.length,
    arrows: false,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 5000,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 3,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  };

  return (
    <div className='bg-[#F8FBFB] dark:bg-[#0D0D0D] max-w-full h-auto py-10 rounded-xl px-4 md:px-10'>
      <h3 className='text-center dark:text-white text-3xl md:text-6xl mb-10 font-semibold uppercase'>
        CERTIFICAZIONI
      </h3>

      <Slider {...settings}>
        {/* slider array */}

        {sliderImg.map((item, i) => (
          <div
            key={i}
            className='flex items-center justify-center h-[120px] px-8'
          >
            <img
              className='max-h-[80px] max-w-[180px] object-contain'
              src={item}
              alt='certification logo'
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default SliderCommon;
